import { call, put, takeLatest } from 'redux-saga/effects';

import {
  OPEN_PLATFORM_PARTNER_CONSENT_PAGE_REQUEST,
  OPEN_PLATFORM_PARTNER_CONSENT_REGISTER_MERCHANT_CONSENT,
} from '../../actions/openPlatform/partnerConsent/constants';
import * as actPartnerConsent from '../../actions/openPlatform/partnerConsent';

import * as apiPartners from '../../api/partner';
import { assertErrorHasMessage } from '../../utils/assert';

export function* pageRequestFlow(request) {
  yield put(actPartnerConsent.reset());
  yield put(actPartnerConsent.resetErrorMessage());
  const {
    payload: { id },
  } = request;

  try {
    const response = yield call(apiPartners.getPartnerDetail, id);

    if (response.data.is_registered) {
      const responseRegisterMerchantConsent = yield call(
        apiPartners.registerMerchantConsent,
        id
      );

      if (!responseRegisterMerchantConsent.data.encrypted_business_id) {
        throw new Error('Missing data from response');
      }

      const redirectURL = new URL(response.data.redirect_uri);
      redirectURL.searchParams.append(
        'ebi',
        responseRegisterMerchantConsent.data.encrypted_business_id
      );
      window.location.href = redirectURL.href;
    } else {
      yield put(
        actPartnerConsent.setPartnerDetail({ partnerDetail: response.data })
      );
      yield put(actPartnerConsent.showAllowModal());
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(
      actPartnerConsent.setErrorMessage({ errorMessage: error.message })
    );
    yield put(actPartnerConsent.showErrorModal());
  }
}

export function* registerMerchantConsent(request) {
  yield put(actPartnerConsent.resetErrorMessage());
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    payload: { id, redirect_uri },
  } = request;

  try {
    const response = yield call(apiPartners.registerMerchantConsent, id);
    if (!response.data.encrypted_business_id) {
      throw new Error('Missing data from response');
    }
    const redirectURL = new URL(redirect_uri);
    redirectURL.searchParams.append('ebi', response.data.encrypted_business_id);
    window.location.href = redirectURL.href;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(
      actPartnerConsent.setErrorMessage({ errorMessage: error.message })
    );
    yield put(actPartnerConsent.showErrorModal());
  }
}

export default function* saga() {
  yield takeLatest(OPEN_PLATFORM_PARTNER_CONSENT_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(
    OPEN_PLATFORM_PARTNER_CONSENT_REGISTER_MERCHANT_CONSENT,
    registerMerchantConsent
  );
}
